module.exports = __webpack_public_path__ + "static/media/bar.bb2a33f2.png";